/**
 * @generated SignedSource<<b44aa04fdfe78fa528b9c82adc45f890>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStyleMainArticleListSection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleSectionSection">;
  readonly " $fragmentType": "sectionStyleMainArticleListSection";
};
export type sectionStyleMainArticleListSection$key = {
  readonly " $data"?: sectionStyleMainArticleListSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStyleMainArticleListSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionStyleMainArticleListSection",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "sectionStyleSectionSection"
    }
  ],
  "type": "Section",
  "abstractKey": null
};

(node as any).hash = "f15c97e07f127c351a2b7978719ca2f1";

export default node;
